var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 24,
    viewBox: "0 0 7 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.937781 21.5236C0.937781 22.8775 1.92703 24 3.23077 24C4.52879 24 5.51804 22.8775 5.51804 21.5236C5.51804 20.1813 4.52879 19.0473 3.23077 19.0473C1.97849 19.0473 0.937781 20.1234 0.937781 21.5236Z",
    fill: "#F1F8FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15779 14.2797L6.41007 2.97396L6.46154 2.52266C6.46154 1.67792 5.92975 0.925747 5.11777 0.474446C4.58598 0.173578 3.9341 0 3.23077 0C1.45813 0 0 1.12247 0 2.52266L0.0571818 2.97396L1.30374 14.2797C1.30374 15.4021 2.19006 16.351 3.23077 16.351C3.89408 16.351 4.49449 15.9691 4.84329 15.3906C5.04343 15.0665 5.15779 14.6847 5.15779 14.2797Z",
    fill: "#F1F8FD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBang);
export default __webpack_public_path__ + "static/media/bang.40440f966d5fdc578b14cc172e727c1d.svg";
export { ForwardRef as ReactComponent };